import { GruendungsartEnum } from '../v2024';

export const GruendungsartEnumLabels = {
    _1: '1' as GruendungsartEnum,
    _2: '2' as GruendungsartEnum,
    _3: '3' as GruendungsartEnum,
    _4: '4' as GruendungsartEnum
};

